import React, { Dispatch, SetStateAction } from 'react';
import { StyleSheet, View } from 'react-native';
import CreationOption, { TemplateUpdateOption } from './components/CreationOption';
import isMobile from '../../../../IsMobile';

interface CreationOptionListProps {
  setInitialOption: Dispatch<SetStateAction<TemplateUpdateOption>>,
}

const CreationOptionList = ({
  setInitialOption,
}: CreationOptionListProps) => <View style={styles.initialOptionsContainer}>
    <CreationOption
      onPress={() => setInitialOption(TemplateUpdateOption.DEFAULT)}
      title='Default'
      description='Create a template from a ready-made preset'
      testID='default-template-button'
    />
    <CreationOption
      onPress={() => setInitialOption(TemplateUpdateOption.CUSTOM)}
      title='Custom'
      description='Create a template completely from scratch'
      testID='custom-template-button'
    />
    <CreationOption
      onPress={() => setInitialOption(TemplateUpdateOption.VARIANT)}
      title='Create from existing'
      description='Create a template based off of an existing template'
    />
  </View>;

const styles = StyleSheet.create({
  initialOptionsContainer: {
    paddingHorizontal: isMobile ? 16 : 40,
  },
});

export default CreationOptionList;
